


































































































































































import Vue from "vue";
import AddSearchFeedback from "./AddSearchFeedback.vue";
import ZenyaDialog from "./../dialogs/ZenyaDialog.vue";
import { ContentItem, Portal } from "@infoland/iprova-api";
import { RecommendedLink } from "../../types/recommendedLink";
import Shared from "../../shared";
import { debounce } from "@/utils";

export default Vue.extend({
    name: "ContentItemsList",
    components: {
        AddSearchFeedback,
        ZenyaDialog
    },
    data: () => {
        return {
            loadingData: false as boolean,
            showSearchFeedbackDialog: false as boolean,
            addFeedbackOption: false as boolean,
            enableTransition: true as boolean,
            isMobile: false as boolean
        };
    },
    props: {
        items: { type: Array as () => ContentItem[] },
        recommendedLinks: { type: Array as () => RecommendedLink[] },
        showIdentifierInTitle: Boolean,
        loadingInProgress: { type: Boolean, required: true },
        isSearchingInAllPortals: Boolean,
        searchText: String,
        portal: Object as () => Portal,
        mdAndDown: Boolean,
        totalNumberOfItems: Number,
        toggleOptionChanged: Boolean,
        isSearchCorrectionDisplayed: Boolean
    },
    watch: {
        searchChanged: {
            immediate: false,
            handler() {
                this.addFeedbackOption = false;
                this.enableTransition = true;
            }
        },
        toggleOptionChanged: {
            immediate: false,
            handler() {
                this.addFeedbackOption = false;
                this.enableTransition = true;
            }
        },
        isSkeletonVisible: {
            immediate: false,
            handler(newValue) {
                // if the content items list is not scrollable (the list is short)
                // then feedback option is added without transition
                // timeout is needed because the list is always displayed
                setTimeout(() => {
                    const contentItemContainer = document.getElementById("contentItemsContainer");
                    if (newValue === false && contentItemContainer?.scrollHeight <= contentItemContainer?.clientHeight) {
                        this.addFeedbackOption = true;
                        this.enableTransition = false;
                    }
                }, 100);
            }
        },
        enableFeedback: {
            immediate: false,
            handler(newValue) {
                if (newValue === true) {
                    setTimeout(() => {
                        const contentItemContainer = document.getElementById("contentItemsContainer");
                        if (contentItemContainer?.scrollHeight > contentItemContainer?.clientHeight && !this.isMobile) {
                            const searchFeedbackContainer = document.getElementById("searchFeedback");
                            searchFeedbackContainer.classList.remove("mr-4");
                            searchFeedbackContainer.classList.add("mr-8");
                        }
                    }, 100);
                }
            }
        }
    },
    // hide-overflow is needed because when adding search feedback with animation
    // the html gets a scrollbar while the animation is playing
    // on destroyed the class is removed
    created() {
        document.getElementsByTagName("html")[0].classList.add("hide-overflow");
    },
    destroyed() {
        document.getElementsByTagName("html")[0].classList.remove("hide-overflow");
    },
    computed: {
        isSkeletonVisible(): boolean {
            return this.items == null || this.loadingInProgress;
        },
        searchedInAllPortalsVisible(): boolean {
            return this.$route.name == "Search";
        },
        enableFeedback(): boolean {
            //feedback can only be done when searching a portal
            return this.portal != null && this.searchText != "" && this.addFeedbackOption;
        },
        searchChanged(): string {
            return this.isSearchingInAllPortals.toString() + this.searchText;
        },
        contentItemsListMaxHeight(): string {
            let otherHeights = 0;
            if (this.$vuetify.breakpoint.xs) {
                otherHeights += 138;
                if (this.isSearchingInAllPortals || this.$route.name == "Browse") {
                    otherHeights -= 58;
                }
            } else if (this.$vuetify.breakpoint.sm) {
                otherHeights += 186;
            } else if (this.$vuetify.breakpoint.mdAndDown) {
                otherHeights += 194;
            } else {
                otherHeights += 218;
            }
            if (this.isSearchCorrectionDisplayed) otherHeights += 40;
            return `calc(100vh - ${otherHeights}px)`;
        }
    },
    methods: {
        buildTitle(contentItem: ContentItem): string {
            return this.showIdentifierInTitle && contentItem.identifier ? contentItem.identifier + " - " + contentItem.title : contentItem.title;
        },
        isDividerVisible(index: number): boolean {
            return this.items && index + 1 < this.items?.length;
        },
        isRecommendedLink(item: ContentItem): boolean {
            const link = this.recommendedLinks?.find(rl => rl.content_item.content_item_id == item.content_item_id);
            return link != null;
        },
        isRecommendedLinkDivider(index): boolean {
            return index === this.recommendedLinks?.length - 1;
        },
        isSummaryAvailable(item: ContentItem) {
            return item.summary ? true : false;
        },
        itemClicked(item: ContentItem) {
            const link = this.recommendedLinks?.find(rl => rl.content_item.content_item_id == item.content_item_id);
            const recommendedLinkId = link?.recommended_link_id;
            this.$emit("clicked", item, recommendedLinkId);
        },
        getContentItemUrl(item: ContentItem): string {
            return Shared.iProvaUrl + `/iPortal5/default.aspx?ContentItemID=${item.content_item_id}`;
        },
        loadContentItems() {
            this.$emit("load-more-items");
        },
        searchInAllPortals() {
            this.$emit("search-in-all-portals", this.searchText);
        },
        showInfoButton(item: ContentItem) {
            if (item.changes || item.summary || item.has_tooltip_fields) {
                return true;
            }
            return false;
        },
        openDetails: function (item: ContentItem) {
            this.$emit("open-content-item-details", item);
        },
        handleScroll: debounce(function (this: any): void {
            const contentItemsContainer = document.getElementById("contentItemsContainer");
            // if the user scrolls more than 400 px
            // or the user scrolled to the bottom of the list and the list is scrollable
            // add search feedback with transition
            if (
                contentItemsContainer.scrollTop > 400 ||
                (contentItemsContainer.scrollHeight - contentItemsContainer.offsetHeight - contentItemsContainer.scrollTop < 1 &&
                    contentItemsContainer?.scrollHeight > contentItemsContainer?.clientHeight)
            ) {
                this.enableTransition = true;
                this.addFeedbackOption = true;
            }
        }, 100),
        getScrollbarWidth(): number {
            const contentItemContainer = document.getElementById("contentItemsContainer");
            if (contentItemContainer?.scrollHeight <= contentItemContainer?.clientHeight) {
                return 0;
            } else {
                // Creating invisible container
                const outer = document.createElement("div");
                outer.style.visibility = "hidden";
                outer.style.overflow = "scroll"; // forcing scrollbar to appear
                document.body.appendChild(outer);

                // Creating inner element and placing it in the container
                const inner = document.createElement("div");
                outer.appendChild(inner);

                // Calculating difference between container's full width and the child width
                const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

                if (scrollbarWidth === 0) this.isMobile = true;
                // Removing temporary elements from the DOM
                outer.parentNode.removeChild(outer);
                return scrollbarWidth;
            }
        }
    }
});
